import { Country } from 'modules/legal_entities/lib/constants'
import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

type StrategyOptions<U> = {
  default: U
  country: Country
  countries: { [key in Country]: IdValidationStrategy }
}

const globalizeStrategy = <U>({
  default: defaultStrategy,
  country,
  countries,
}: StrategyOptions<IdValidationStrategy>): IdValidationStrategy => {
  return countries[country] || defaultStrategy
}

export default globalizeStrategy
